var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4108 13.1667C12.4903 13.1667 11.7441 13.9129 11.7441 14.8333C11.7441 15.7538 12.4903 16.5 13.4108 16.5C14.3313 16.5 15.0775 15.7538 15.0775 14.8333C15.0775 13.9129 14.3313 13.1667 13.4108 13.1667ZM13.4108 13.1667H6.9891C6.60488 13.1667 6.41242 13.1667 6.25423 13.0983C6.11469 13.038 5.99363 12.9409 5.90542 12.8171C5.80656 12.6783 5.7668 12.4928 5.68809 12.1254L3.63704 2.55387C3.55651 2.17803 3.5157 1.99031 3.41569 1.84993C3.32749 1.72612 3.20645 1.62868 3.0669 1.56837C2.90869 1.5 2.7173 1.5 2.33292 1.5H1.74414M4.24414 4H14.9718C15.5733 4 15.8737 4 16.0756 4.1253C16.2524 4.23505 16.3819 4.40718 16.4383 4.6075C16.5028 4.83619 16.42 5.12497 16.2533 5.70288L15.0994 9.70288C14.9998 10.0484 14.9499 10.2209 14.8488 10.3491C14.7595 10.4622 14.6418 10.5508 14.5083 10.6052C14.3576 10.6667 14.1784 10.6667 13.8209 10.6667H5.6862M5.91081 16.5C4.99033 16.5 4.24414 15.7538 4.24414 14.8333C4.24414 13.9129 4.99033 13.1667 5.91081 13.1667C6.83128 13.1667 7.57747 13.9129 7.57747 14.8333C7.57747 15.7538 6.83128 16.5 5.91081 16.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/product-icon.378f8d6f9b6bccd443881b51de43981a.svg";
export { ForwardRef as ReactComponent };